import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import PropTypes from "prop-types";
import { EducationLevelConsumer } from "../../../data/education-level";
import { msg } from "../translations/components/Message";
import messages from "./messages";

const educationLevelConsumer = new EducationLevelConsumer();

export const EducationLevelSelect = ({ onSelect, value, isDisabled }) => {
    const [val, setVal] = useState({});
    const onValueChange = newValue => {
        setVal(newValue);
        onSelect(newValue);
    };

    return (
        <AsyncSelect
            autoFocus={true}
            clearable={false}
            className="bh-select__container"
            classNamePrefix="bh-select"
            isSearchable={false}
            placeholder={msg(messages.selectLevel)}
            value={[val]}
            defaultOptions
            onChange={onValueChange}
            isDisabled={isDisabled}
            loadOptions={() =>
                educationLevelConsumer.list().then(levels => {
                    setVal(levels.filter(level => level.value === value)[0]);
                    return levels;
                })
            }
        />
    );
};

EducationLevelSelect.propTypes = {
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.string
};
